import { render, staticRenderFns } from "./ModalCreateAndEditCustomFonts.vue?vue&type=template&id=4d8839c2&scoped=true"
import script from "./ModalCreateAndEditCustomFonts.vue?vue&type=script&lang=js"
export * from "./ModalCreateAndEditCustomFonts.vue?vue&type=script&lang=js"
import style0 from "./ModalCreateAndEditCustomFonts.vue?vue&type=style&index=0&id=4d8839c2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8839c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d8839c2')) {
      api.createRecord('4d8839c2', component.options)
    } else {
      api.reload('4d8839c2', component.options)
    }
    module.hot.accept("./ModalCreateAndEditCustomFonts.vue?vue&type=template&id=4d8839c2&scoped=true", function () {
      api.rerender('4d8839c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/ModalCreateAndEditCustomFonts.vue"
export default component.exports